export const getDefaultValues = (gamePreviewDetails) => ({
  GamePreviewTitle: gamePreviewDetails?.GamePreviewTitle || '',
  GamePreviewUrlImage: gamePreviewDetails?.GamePreviewUrlImage || '',
  GamePreviewUrlMp4: gamePreviewDetails?.GamePreviewUrlMp4 || '',
});
